import { Dispatch } from "@reduxjs/toolkit";
import H from "history";
import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import { IStoreState } from "../../reducers/types";
import { actions } from "./actions";
import { actions as availabilityActions } from "../availability/actions";
import { PremiumCollectionOffers } from "./component";
import { RequestStateUtils } from "./reducer";
import { getRewardsAccountWithLargestEarnForBanner } from "../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  lodgingPromotionResponse:
    state.premiumCollectionOffersSearch.premiumOffersShopCall ??
    RequestStateUtils.notCalled(),
  rewardsAccount: getRewardsAccountWithLargestEarnForBanner(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchPremiumOffersShop: (
    history: H.History,
    params: IOfferAvailabilityRequest
  ) => dispatch(actions.fetchPremiumOffersShop(history, params)),
  setSelectedLodgingIndex: (index: number) =>
    dispatch(availabilityActions.setSelectedLodgingIndex(index)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PremierCollectionAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPremiumCollectionOffers = withRouter(
  connector(PremiumCollectionOffers)
);
